<div class="content">

  <!-- since last login-->
   @if(loadpage !== 'lastlogin' && lastLoginTimestamp) {
     <div class="card news">
       <ul class="p-0 m-0 news" style="width: 100%">
         @if(loadLastVisit) {
           <div class="row justify-content-center">
             <div class="spinner-border text-primary" role="status">
               <span class="visually-hidden">{{ 'pages.generic.loading' | translate }}</span>
             </div>
           </div>
          } @else {
            <a class="click" (click)="loadSinceLastVisit(true)">
              <li class="mb-2">
                <span [ngClass]="context.isDarkTheme() ? 'lighter-blue' : 'darker-blue'">
                  {{ sinceLastLogin }}
                </span>
                {{ 'pages.updates.signal.sinceLastVisitPost' | translate }}
              </li>
            </a>
          }
       </ul>
     </div>
   }

  <div class="pb-3">
    <div class="card search-card">
      
      <div class="card-title">
        <div class="search-checkboxes">
          <!--advanced search -->
          <div class="form-check form-switch custom-switch right me-3" style="float:left" data-toggle="tooltip"
            data-placement="top" title="{{ 'pages.worldwatch.enableAdvSrchDesc' | translate }}">
            <input class="form-check-input" type="checkbox" [attr.aria-checked]="advSearch" role="switch"
              id="advanceSearch"  [(ngModel)]="advSearch">
            <label class="custom-control-label" for="advanceSearch">{{ 'pages.generic.advancedSearch' | translate
              }} </label>
          </div>
          <!-- saved search -->
          <div class="form-check form-switch custom-switch right" style="float:left" data-toggle="tooltip"
            data-placement="top" title="{{ 'pages.worldwatch.enableSavedSearchDesc' | translate }}">
            <input class="form-check-input" type="checkbox" [attr.aria-checked]="openSaveSearch" role="switch"
              id="openSaveSearch" [(ngModel)]="openSaveSearch">
            <label class="custom-control-label" for="openSaveSearch">{{ 'pages.generic.savedSearches' | translate
              }}</label>
          </div>
        </div>
      </div>
      

      <div class="card-body">
        

        <form [formGroup]="advisoryForm">
          <!--simple search -->
          <div class="row">

            <!-- id -->
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-3 mb-3" data-toggle="tooltip" data-placement="top"
              title="{{ 'pages.worldwatch.searchSignalDesc' | translate }}">
              <label for="referenceInput">{{ 'pages.updates.signal.fieldTitles.reference' | translate }} <app-help message="{{ 'pages.updates.signal.fieldTitles.referenceHelper' | translate }}"></app-help> </label>
              <input type="text" class="form-control" id="referenceInput" name="id"
                formControlName="id">
            </div>

            <!-- title -->
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-3 mb-3" data-toggle="tooltip" data-placement="top">
              <label for="queryInput">{{ 'pages.updates.signal.fieldTitles.title' | translate }}</label>
              <input type="text" class="form-control" id="queryInput" name="query"
                [placeholder]="'pages.updates.signal.fieldTitles.title' | translate" formControlName="title">
            </div>

            <!-- severity -->
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-3 mb-3">
              <div class="custom-label" id="urgencyFilter">{{ 'pages.updates.signal.fieldTitles.severity' | translate
                }}</div>
              <ng-multiselect-dropdown [settings]="dropdownSettings" formControlName="severity" [data]="urgenciesData"
                name="typeFilter" aria-labelledby="urgencyFilter">
              </ng-multiselect-dropdown>
            </div>

            <!-- threatCategoryTitle -->
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-3 mb-3">
              <div class="custom-label" id="urgencyFilter">{{ 'pages.updates.signal.fieldTitles.category' | translate
                }}</div>
                  <ng-multiselect-dropdown [settings]="dropdownSettings" formControlName="threatCategoryTitle" [data]="threatCategories"
                  name="typeFilter" aria-labelledby="urgencyFilter">
                  </ng-multiselect-dropdown>
            </div>

            <!-- tag types -->
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-3 mb-3">
              <label for="tagType">{{ 'pages.updates.signal.fieldTitles.tagType' | translate }}</label>
              <select class="form-select" id="tagType" name="tagType" formControlName="tagType">
                <option value="all">{{ 'pages.updates.signal.fieldTitles.all' | translate }}</option>
                <option value="country">{{ 'pages.updates.signal.fieldTitles.country' | translate }}</option>
                <option value="region">{{ 'pages.updates.signal.fieldTitles.region' | translate }}</option>
                <option value="sector">{{ 'pages.updates.signal.fieldTitles.sector' | translate }}</option>
              </select>
            </div>

            @if(tagType.value === 'all') {
              <!-- tags -->
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-3 mb-3">
                <label for="tag">{{ 'pages.updates.signal.fieldTitles.tag' | translate }}</label>
                <select class="form-select"  id="tag" name="tag" formControlName="tag">
                  <option></option>
                  @for(tag of tags; track tag){
                    <option [value]="tag.key">{{tag.label}}</option>
                  }
                </select>
              </div>
            } @else if(tagType.value === 'country') {
              <!-- country -->
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-3 mb-3">
                <label for="country">{{ 'pages.updates.signal.fieldTitles.tag' | translate }}</label>
                <select class="form-select"  id="country" name="country" formControlName="tag">
                  <option></option>
                  @for(country of countryTags; track country){
                    <option [value]="country.key">{{country.label}}</option>
                  }
                </select>
              </div>
            } @else if(tagType.value === 'sector') {
              <!-- sector -->
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-3 mb-3">
                <label for="sector">{{ 'pages.updates.signal.fieldTitles.tag' | translate }}</label>
                <select class="form-select"  id="sector" name="sector" formControlName="tag">
                  <option></option>
                  @for(sector of sectorTags; track sector){
                    <option [value]="sector.key">{{sector.label}}</option>
                  }
                </select>
              </div>

            } @else if(tagType.value === 'region') {
              <!-- region -->
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-3 mb-3">
                <label for="region">{{ 'pages.updates.signal.fieldTitles.tag' | translate }}</label>
                <select class="form-select"  id="region" name="region" formControlName="tag">
                  <option></option>
                  @for(region of regionTags; track region){
                    <option [value]="region.key">{{region.label}}</option>
                  }
                </select>
              </div>
            }

          </div>

          <!-- advanced search -->
          <div [ngbCollapse]="!advSearch" id="advSearch">
            
            <!-- created date -->
            <div class="row">

              <!-- from -->
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3 mb-3" data-toggle="tooltip" data-placement="top">
                <div class="custom-label">
                  {{ 'pages.updates.signal.fieldTitles.createdFrom' | translate }}
                </div>
                <div class="row">
                  <span class="visually-hidden" id="publishedFromLabel">{{
                    'pages.updates.signal.fieldTitles.publishedFrom' | translate }}</span>
                  <div class="col-12">
                    <input type="datetime-local" class="form-control" name="publishFrom" aria-labelledby="publishedFromLabel" formControlName="createdAfter"
                      [ngClass]="{'is-invalid': createdRange.errors?.incorrect}">
                  </div>
                  </div>
                </div>              

                <!-- to -->
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3 mb-3" data-toggle="tooltip" data-placement="top">
                <div class="custom-label">
                  {{ 'pages.updates.signal.fieldTitles.createdTo' | translate }}
                </div>
                <div class="row">
                </div>
                <span class="visually-hidden" id="publishedToLabel">{{
                  'pages.updates.signal.fieldTitles.publishedTo' | translate }}</span>
                  <div class="col-12">
                    <input type="datetime-local" class="form-control is-invalid" name="publishTo" aria-labelledby="publishedToLabel" formControlName="createdBefore"
                    [ngClass]="{'is-invalid': createdRange.errors?.incorrect}">
                  </div>
                </div>

              <!-- updated date -->
              <!-- from -->
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3 mb-3" data-toggle="tooltip" data-placement="top">
                <div class="custom-label">
                  {{ 'pages.updates.signal.fieldTitles.updatedFrom' | translate }}
                </div>
                <div class="row">
                  <span class="visually-hidden" id="publishedFromLabel">{{
                    'pages.updates.signal.fieldTitles.publishedFrom' | translate }}</span>
                  <div class="col-12">
                    <input type="datetime-local" class="form-control" name="publishFrom" aria-labelledby="publishedFromLabel" formControlName="updatedAfter"
                      [ngClass]="{'is-invalid': updatedRange.errors?.incorrect}">
                  </div>
                  </div>
                </div>              

                <!-- to -->
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3 mb-3" data-toggle="tooltip" data-placement="top">
                <div class="custom-label">
                  {{ 'pages.updates.signal.fieldTitles.updatedTo' | translate }}
                </div>
                <div class="row">
                </div>
                <span class="visually-hidden" id="publishedToLabel">{{
                  'pages.updates.signal.fieldTitles.publishedTo' | translate }}</span>
                  <div class="col-12">
                    <input type="datetime-local" class="form-control" name="publishTo" aria-labelledby="publishedToLabel" formControlName="updatedBefore"
                    [ngClass]="{'is-invalid': updatedRange.errors?.incorrect}">
                  </div>
                </div>
              </div>

            <!-- created date -->
            <div class="row">

              <!-- created date range error -->
              <div class="col-6 mb-3" data-toggle="tooltip" data-placement="top">
              @if(createdRange.errors?.incorrect) {
                <div class="alert alert-danger alert-sm" role="alert">
                  <span class="alert-icon"><span class="visually-hidden">Error</span></span>
                  <p>{{ 'pages.updates.signal.fieldTitles.dateHelper' | translate }}</p>
                </div>
                }        
              </div>              

              <!-- updated date range error -->
              <div class="col-6 mb-3" data-toggle="tooltip" data-placement="top">
              @if(updatedRange.errors?.incorrect) {
                <div class="alert alert-danger alert-sm" role="alert">
                  <span class="alert-icon"><span class="visually-hidden">Error</span></span>
                  <p>{{ 'pages.updates.signal.fieldTitles.dateHelper' | translate }}</p>
                </div>
                }
              </div>
            </div>
        </div>

          <div>
            <button class="btn btn-primary" (click)="applySearch()" [disabled]="createdRange.errors?.incorrect || updatedRange.errors?.incorrect">{{ 'pages.generic.filter' | translate }}</button>
            <button class="btn btn-primary" (click)="reset(true)">{{ 'pages.generic.reset' | translate }}</button>
            <button class="btn btn-primary save-search" (click)="openSearchModal()" [disabled]="!hasActiveFilter()"
              data-toggle="tooltip" data-placement="top" title="{{ 'pages.worldwatch.saveSearchDesc' | translate }}">
              {{ 'pages.generic.saveSearch' | translate }}
            </button>
          </div>

        </form>
      </div>
    </div>

    @if(savedFilters && savedFilters.length > 0) {
      <div class="card" [ngbCollapse]="!openSaveSearch"
        id="savedSearch">
        <div class="card-body save-search">
          <div class="row">
            <div class="col-12">
            <!-- save search buttons -->
            @for(filter of savedFilters; track $index) {
              <span style="float: left">
                <button class="btn btn-secondary mt-1 search" title="{{filter.name}}"
                  [ngClass]="{'selected': selectedFilter && selectedFilter.name === filter.name}"
                  (click)="loadSelectedFilter(filter)">
                  {{ filter.name }}
                </button>
              </span>
            }
            </div>
            
          </div>
          <div class="row mt-1">
            <div class="col-12">
              <!-- delete search button -->
              <button class="btn btn-primary mt-1" data-toggle="tooltip" data-placement="top"
                [disabled]="!selectedFilter" title="{{ 'buttons.action.deleteSearch' | translate }}"
                (click)="deleteSearch()">
                {{ 'buttons.action.deleteSearch' | translate }}
              </button>
              <!-- update search button -->
              <button class="btn btn-primary mt-1" data-toggle="tooltip" data-placement="top"
                [disabled]="!selectedFilter" title="{{ 'buttons.action.updateSearch' | translate }}"
                (click)="saveSearch(true)">
                {{ 'buttons.action.updateSearch' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="rowfiller" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
    (scrolled)="loadAdvisories(true)">
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{ 'active' : page === signalsPage }"
          (click)="page = signalsPage; displayAdvisories();">{{ 'pages.updates.signal.signals' | translate }}
          <span class="tag no-border text-bg-primary ms-2" style="padding:0rem 0.5rem;"
            *ngIf="signalsCount">{{signalsCount}}</span>
        </a>
      </li>
      <li class="nav-item" data-toggle="tooltip" data-placement="top"
        title="{{ 'pages.worldwatch.signalFlagDesc' | translate }}">
        <a class="nav-link" [ngClass]="{ 'active' : page === flaggedPage }" (click)="displayFlaggedAdvisories();">{{
          'pages.generic.flagged' | translate }}
          <span class="tag no-border text-bg-primary ms-2" style="padding:0rem 0.5rem;">{{userPreferenceService.userPreferences?.flags?.worldwatch?.length}}</span>
        </a>
      </li>
    </ul>
    <br /><br />

    <div class="card-body p-t-1 p-0">
      <app-signal-list [(form)]="advisoryForm" [signals]="signals" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loading]="loading" [canSort]="page === signalsPage"
      (sortEmitter)="onSort($event)" (flagEmitter)="flag($event)"></app-signal-list>
    </div>

    <div class="row justify-content-center p-5" *ngIf="scrollLoading && (page === signalsPage || page === flaggedPage)">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ 'pages.generic.loading' | translate }}</span>
      </div>
    </div>
  </div>
</div>